export default __webpack_public_path__ + "static/media/ic-art-search-track.3661d4fb.svg";